<template>
  <TransitionRoot :show="open" as="template">
    <Dialog class="relative z-50" :initial-focus="panelRef" @close="() => {}">
      <TransitionChild
        as="template"
        enter="duration-200 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-150 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 top-96 bg-black/70" />
      </TransitionChild>
      <div class="fixed inset-0 top-96 flex items-center justify-center p-20">
        <TransitionChild
          as="template"
          enter="duration-200 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-150 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel
            ref="panelRef"
            class="font-poppins max-h-full w-full overflow-y-auto rounded-2xl bg-white shadow-xl"
            :class="panelClass"
          >
            <slot />
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { ref } from 'vue';

const panelRef = ref();
defineProps({
  open: { type: Boolean, required: true },
  panelClass: { type: String, default: 'max-w-600' },
});
</script>
